import type { ColorToken } from "../types";

export function removeUngroupedColor(
  colors: ColorToken[],
  colorName: string,
): ColorToken[] {
  return colors.filter((c) => c.name !== colorName);
}
